import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CheckboxFilter, CheckboxFilterVm, PickedRange, RangePicketVm } from '@shared/filters/entities/fetch-filters.response';
import { isEmpty } from '@app/util/util';
import { GlobalFacade } from '@app/global.facade';

@Injectable({
  providedIn: 'root'
})
export class HotelFilterBarService {

  constructor(
    private readonly globalFacade: GlobalFacade,
  ) { }

  get sortingHasBeenChangedByHotel$(): Observable<boolean> {
    return this.globalFacade.ui.results.filters.sortingHasBeenChanged$;
  }

  public sortingHasBeenChangedByHotel(payload: boolean): void {
    this.globalFacade.ui.results.filters.sortingHasBeenChanged(payload);
  }

  public checkedHotelCheckbox(
    pickedCheckboxes: string[], pickedStars: string[], selectedStarItems: CheckboxFilter[],
    item: CheckboxFilterVm, isCheckboxFilter: boolean
  ): { [key: string]: boolean } {
    if (isCheckboxFilter) {
      return {
        include: pickedCheckboxes.includes(item.Text), addStars: false,
      };
    } else {
      const include = pickedStars.map(_item => _item).includes(item.Text);
      const addStars = include && !selectedStarItems.find(_item => _item.Text === item.Text);
      return { include, addStars };
    }
  }

  public checkedHotelRanges(pickedRanges: PickedRange, type: string): string[] | number[] | RangePicketVm {
    return pickedRanges && !isEmpty(pickedRanges[type]) ? pickedRanges[type] : null;
  }

}
